export const getSinglePageData = (payload) => ({
  payload,
  type: 'GET_SINGLE_PAGE_DATA',
})

export const setSinglePageData = (payload) => ({
  payload,
  type: 'SET_SINGLE_PAGE_DATA',
})

export const clearSinglePageData = () => ({
  type: 'CLEAR_SINGLE_PAGE_DATA',
})

export const setLoading = (payload) => ({
  payload,
  type: 'SET_LOADING',
})

export const updateSinglePageField = (payload) => ({
  payload,
  type: 'UPDATE_SINGLE_PAGE_FIELD',
})